import { Form, Space, Switch } from 'antd';
import { FormCard } from '../../../../../features/FormCard';
import { AppBox } from '../../../../../../../../../ui/boxes/AppBox';
import { AppText } from '../../../../../../../../../ui/text/AppText';
import { useLocalization } from '../../../../../../../../../lib/hooks/useLocalization';
import { SurveyTypeFormItem } from '../../../../../features/form-items/SurveyTypeFormItem';
import { FormItemName } from '../../../../../../../../../lib/models/Form';

export function SurveyType({ form }) {
  const { general } = useLocalization().translations.unique.pages.settings;

  const toggleRecommendedProductsSelected = checked => {
    form.setFieldValue(FormItemName.RECOMMENDED_PRODUCTS_SELECTED, checked);
  };

  return (
    <FormCard>
      <AppBox className='space_between' style={{ marginBottom: 24 }}>
        <AppText className='bold' textValue={general.surveyType} />
      </AppBox>
      <SurveyTypeFormItem form={form} />
      <Form.Item name={FormItemName.RECOMMENDED_PRODUCTS_SELECTED} noStyle>
        <Space size='small' style={{ display: 'flex', alignItems: 'center' }}>
          <Switch checked={Form.useWatch(FormItemName.RECOMMENDED_PRODUCTS_SELECTED, form)} onChange={toggleRecommendedProductsSelected} />
          <AppText textValue={general.recommendedProductsSelected} />
        </Space>
      </Form.Item>
    </FormCard>
  );
}
